import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperDialog: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerFiledItem: {
      display: "flex",
      flexDirection: "row",
      gap: "20px",
    },
    titleItem: {
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      lineHeight: "20px",
      maxWidth: "280px",
      minWidth: "160px",
    },
    subTitleItem: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
      lineHeight: "20px",
    },
    containerTitles: {
      maxWidth: "280px",
      minWidth: "160px",
      display: "flex",
      flexDirection: "column",
    },
    uploadedSection: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "16px",
    },
    sectionImage: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    containerImageTitle: {
      display: "flex",
      gap: "8px",
    },
    ImageTitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.secondary,
      lineHeight: "20px",
    },
    containerUploadedFiles: {
      display: "flex",
      gap: "12px",
      flexWrap: "wrap",
    },
    cardUploadedFilesInfo: {
      width: "218px",
      height: "200px",
      position: "relative",
      overflow: "hidden",
    },
    containerImage: {
      width: "100%",
      height: "100%",
    },
    wrapperImage: {
      width: "100%",
      height: "100%",
    },
    containerDeleteIcon: {
      position: "absolute",
      width: 48,
      height: 48,
      top: 8,
      right: 8,
      zIndex: 2,
      borderRadius: "12px",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      backgroundColor: "rgba(16, 24, 40, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    containerPlaceHolderImage: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "14px",
      borderRadius: "12px",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      backgroundColor: "rgba(16, 24, 40, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
    },
  };
});
